module.exports = __webpack_public_path__ + "static/media/custom.82e86c17.svg";